import React from 'react';

const Whatsapp = () => {
  return (
    <div className="flex items-center justify-center w-16 h-16 bg-white rounded-full shadow-lg overflow-hidden">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-10 h-10 text-orange-600"
        viewBox="0 0 32 32"
        fill="currentColor"
      >
        <path d="M16 3C9.372 3 4 8.372 4 15c0 2.539.776 4.892 2.107 6.858L4 28l6.377-1.997A12.962 12.962 0 0016 27c6.628 0 12-5.372 12-12S22.628 3 16 3zm0 22c-1.996 0-3.91-.493-5.574-1.431l-.39-.214-3.318 1.04 1.11-3.286-.27-.424A9.972 9.972 0 016 15c0-5.522 4.478-10 10-10s10 4.478 10 10-4.478 10-10 10zm5.523-7.68c-.33-.165-1.948-.965-2.255-1.075-.307-.11-.533-.165-.756.165-.222.33-.865 1.075-1.057 1.293-.193.22-.357.243-.662.082-.307-.165-1.294-.476-2.215-1.332-.818-.73-1.371-1.63-1.53-1.9-.165-.275-.017-.418.123-.552.126-.126.276-.33.41-.495.135-.165.193-.275.29-.46.096-.193.048-.36-.024-.495-.073-.137-.637-1.532-.872-2.19-.23-.643-.467-.55-.662-.56h-.57c-.193 0-.505.073-.765.366-.26.292-1 1.043-1 2.537 0 1.495 1.098 2.942 1.252 3.145.165.22 2.015 3.21 4.891 4.5 2.876 1.29 2.876.86 3.465.81.584-.05 1.922-.79 2.192-1.55.275-.762.275-1.415.192-1.537-.082-.122-.3-.2-.63-.363z" />
      </svg>
    </div>
  );
};

export default Whatsapp;
